export default __webpack_public_path__ + "static/media/property_659.19287af4.png";